import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EXPERIMENT_CELL_METADATA_UPDATED } from 'redux/actionTypes/experiments';
import endUserMessages from 'utils/endUserMessages';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import UploadStatus from 'utils/upload/UploadStatus';
var updateCellLevelMetadataFileUpload = function updateCellLevelMetadataFileUpload(experimentId, uploadStatus, percentProgress) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _url, _body;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(uploadStatus !== UploadStatus.UPLOADING)) {
                _context.next = 11;
                break;
              }
              _url = "/v2/experiments/".concat(experimentId, "/cellLevelMeta");
              _body = {
                uploadStatus: uploadStatus
              };
              _context.prev = 3;
              _context.next = 6;
              return fetchAPI(_url, {
                method: 'PATCH',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(_body)
              });
            case 6:
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](3);
              handleError(_context.t0, endUserMessages.ERROR_UPDATE_SERVER_ON_UPLOAD_STATE);
            case 11:
              dispatch({
                type: EXPERIMENT_CELL_METADATA_UPDATED,
                payload: {
                  experimentId: experimentId,
                  cellLevelMetadata: {
                    uploadStatus: uploadStatus,
                    percentProgress: percentProgress
                  }
                }
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updateCellLevelMetadataFileUpload;